import React,{Component} from "react";
import SearchIcon from "@mui/icons-material/Search";
import IntlMessages from "../../util/IntlMessages"
import TextField from '@mui/material/TextField';
import CloseIcon from '@mui/icons-material/Close';
import InputAdornment from "@mui/material/InputAdornment";
import PeopleIcon from "../../assets/svg/PeopleIcon";
import IconButton from "@mui/material/IconButton";

class SearchActivities extends Component
{
    state={
        search:''
    }

    handelSearch = (value) => {
         this.setState({...this.state,search:value});
         this.props.handelSearchActivities(value)
    }

    render() {
        let {search, isFilterAppllied} = this.state;
        const {touchpointFilter} = this.props
        return (
        <div className="row mt-2 assign-activity justify-content-center assign-activity-search">
            <div className="d-flex col-lg-6 col-md-12">
               <div data-testid="searchIcon" className="titleIcon searchFieldIcon mr-1">
                   <SearchIcon color="primary"/>
               </div>
               <IntlMessages id="assignActivity.searchActivity">{
                 placeholder =>
                    <TextField id="standard-search" 
                        data-testid="searchField" 
                        onChange={(e) => this.handelSearch(e.target.value)}
                        onKeyDown={(e) => { if (e.key === 'Enter') e.target.blur(); }}
                        type="search" 
                        placeholder={`${placeholder}`}
                        value={search ? search: ''}
                        variant="standard"
                        className={ "inputTitle border-0 w-100"} 
                        slotProps={{
                            input:{
                                endAdornment: ( search && search.length > 0 ?
                                    <InputAdornment position="end">
                                        <CloseIcon color="primary" onClick={() => this.handelSearch("")} style={{cursor:"pointer",marginRight:"7px"}}/>
                                    </InputAdornment> :  <InputAdornment position="end"> </InputAdornment>
                                )
                            }
                        }}
                        />
                 }
               </IntlMessages>
               <div className={`${touchpointFilter ? "touchpoint-filter-apply" : "touchpoint-filter" } ml-2`}>
                    <IconButton onClick={() => this.props.handleToupointFilter()}>
                        <PeopleIcon width="24px" height="24px" className="people-left-right-icon" />
                    </IconButton>
               </div>
           </div>
       </div>
        )
    }
}
export default SearchActivities;